import React from 'react'

import UsageUnitLockPeriodReasonRendererHelper from '../../../components/AgGrid/RendererHelper/UsageUnitLockPeriodReasonRendererHelper'

const UsageUnitLockPeriodReasonRenderer = (props) => {
  return <UsageUnitLockPeriodReasonRendererHelper {...props} />
}

export default UsageUnitLockPeriodReasonRenderer
